import { Injectable, Inject, Component } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable } from 'rxjs';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SaveChangesComponent {
   exitCheck?: () => Observable<boolean> | Promise<boolean> | boolean;
   exitCheckWithDialog?: () => boolean;
}

@Component({
   selector: `lib-save-changes-dialog`,
   template: `
      <h2 mat-dialog-title>{{title}}</h2>
      <div mat-dialog-content>{{message}}</div>
      <mat-dialog-actions>
         <button mat-raised-button color="primary" [mat-dialog-close]="true">{{yes}}</button>
         <button mat-raised-button mat-dialog-close>{{no}}</button>
      </mat-dialog-actions>
   `,
   styles: [
        `.mat-dialog-actions { display: flex; }`,
        `.mat-raised-button { flex-grow: 1; }`,
    ]
})
export class SaveChangesDialogComponent {
   public title = 'Confirm';
   public message = 'Changes will be lost, continue?';
   public yes = 'Ok';
   public no = 'Cancel';

   constructor(
      public dialogRef: MatDialogRef<SaveChangesDialogComponent>,
      @Inject( MAT_DIALOG_DATA ) public data: any
   ) {
      this.title = data.title || this.title;
      this.message = data.message || this.message;
      this.yes = data.yes || this.yes;
      this.no = data.no || this.no;
   }
}

@Injectable()
export class SaveChangesGuard implements CanDeactivate<SaveChangesComponent> {
   constructor( private dialog: MatDialog ) { }

   canDeactivate( component: SaveChangesComponent ): Observable<boolean> | Promise<boolean> | boolean {
      if ( component?.exitCheckWithDialog ) {
         return component.exitCheckWithDialog() ? this.checkWithDialog() : true;
      }

      return component?.exitCheck ? component.exitCheck() : true;
   }

   checkWithDialog(): Observable<boolean> | Promise<boolean> | boolean {
      const dialogRef = this.dialog.open( SaveChangesDialogComponent, {
         data: { message: 'Changes will be lost, continue?' }
      });

      return dialogRef.afterClosed();
   }
}
